import { Box, Typography } from '@mui/material';
import { ReactNode, FormEvent } from 'react';
import { Button, AlertBoxMsg } from '@qrios/frontend-library';

import { BusinessError } from '../business-error';
import locales from '../../../constants/commonLocales';
import { WithChildren } from '../../../constants/interfaces';

export interface Props extends WithChildren {
  formInfoText?: ReactNode;
  onSecondary?: (arg?: any) => void;
  onSubmit: (event?: FormEvent<HTMLFormElement>) => void;
  loading?: boolean;
  secondaryLabel?: ReactNode;
  submitLabel?: ReactNode;
  error?: BusinessError | null;
  disableSubmit?: boolean;
  disableSecondary?: boolean;
  danger?: boolean;
}

const WithFormLayout = ({
  formInfoText,
  children,
  onSecondary,
  onSubmit,
  secondaryLabel = locales.form.button.cancel,
  submitLabel = locales.form.button.apply,
  loading = false,
  error = null,
  disableSubmit = false,
  disableSecondary = false,
  danger = false
}: Props) => (
  <form onSubmit={onSubmit}>
    {formInfoText ? (
      <Box mb={2}>
        <Typography variant="h4">{formInfoText}</Typography>
      </Box>
    ) : null}
    {children}
    {error ? (
      <Box pt={1}>
        <AlertBoxMsg severity={error.severity}>{error.message}</AlertBoxMsg>
      </Box>
    ) : null}
    <Box display="flex" pt={2}>
      {onSecondary ? (
        <Box width="50%" pr={1}>
          <Button
            fullWidth
            text={secondaryLabel}
            onClick={onSecondary}
            data-testid="button-secondary"
            variant="outlined"
            disabled={disableSecondary}
          />
        </Box>
      ) : null}
      <Box width={onSecondary ? '50%' : '100%'} pl={onSecondary ? 1 : 0}>
        <Button
          danger={danger}
          style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}
          fullWidth
          text={submitLabel}
          onClick={onSubmit}
          data-testid="button-primary"
          loading={loading}
          disabled={disableSubmit}
        />
      </Box>
    </Box>
  </form>
);

export default WithFormLayout;
